<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
    <!-- <div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>888-888-888
          <span class="glyphicon glyphicon-envelope"></span>liyunkun_11@163.com
          <span class="glyphicon glyphicon-time"></span>7x24小时为您服务
        </div>
        <div class="shejiao pull-right">
          <span class="glyphicon glyphicon-hand-right"></span>赶快联系我们吧！
          <span class="glyphicon glyphicon-hand-left"></span>
        </div>
      </div>
    </div> -->
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="https://ruiyoo-cdn-image.oss-cn-shenzhen.aliyuncs.com/website/ruiyooImage/logo.png">
        <img src="https://ruiyoo-cdn-image.oss-cn-shenzhen.aliyuncs.com/website/ruiyooImage/logo-titile.png" alt="" class="logo-title">
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li v-for="(item,index) in navList" :key="index" :class="index==navIndex?'active':''"
          @click="navClick(index,item.name)">
          <router-link :to="item.path">
            {{item.name}}
            <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length>0">
            <dt v-for="(i,n) in item.children" :key="n">
              <router-link :to="i.path">{{i.name}}</router-link>
            </dt>
          </dl>
        </li>
        <li class="header-nav-phone" style="margin-left: 40px;">
          <a href="" style="color: #409EFF;">
            <div class="iconfont" style="font-size: 20px; margin-right: 10px;">&#xf072;</div>0755-82517005
          </a>
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img class="center-block" src="https://ruiyoo-cdn-image.oss-cn-shenzhen.aliyuncs.com/website/ruiyooImage/logo.png" alt="logo">
        <img class="center-block-title" src="https://ruiyoo-cdn-image.oss-cn-shenzhen.aliyuncs.com/website/ruiyooImage/logo-titile.png" alt="">
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{menuName}}
        <div class="header-nav-m-menu-wrapper" data-toggle="collapse" data-target="#menu" @click="menuClick">
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li v-for="(item,index) in navList" :key="index" :class="index==navIndex?'active':''"
            @click="navClick(index,item.name)" data-toggle="collapse" data-target="#menu">
            <router-link :to="item.path">
              {{item.name}}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "Header",
    data() {
      return {
        childValue: '1000',
        navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
        menuName: "首页",
        menuClass: "glyphicon glyphicon-menu-down",
        navList: [{
            name: "首页",
            path: "/",
            children: []
          },
          {
            name: "产品与解决方案",
            path: "/software",
            children: [{
                name: "1+N政务辅导生态系统",
                path: "/software/naShui"
              },
              {
                name: "政务问办一体化平台",
                path: "/software/zhiShui"
              },
              {
                name: "业务精准提升平台",
                path: "/software/yeWu"
              },
              {
                name: "动画课件制作",
                path: "/software/animation"
              },
              {
                name: "精品直播间",
                path: "/software/live"
              },
              {
                name: "税企远程可视化交互平台",
                path: "/software/5gkw"
              },
              {
                name: "AI数字人",
                path: "/software/meta"
              }
            ]
          },
          {
            name: "客户案例",
            path: "/",
            children: []
          },
          {
            name: "关于我们",
            path: "/companyintroduction",
            children: []
          }
        ]
      };
    },
    methods: {
      navClick(index, name) {
        this.navIndex = index;
        sessionStorage.setItem('navIndex', index)
        this.menuName = name;
        if (name == "客户案例") {
          this.$router.push({
            path: '/'
          })
          this.$emit('childByValue', this.childValue)
        }
      },
      menuClick() {
        if (this.menuClass == "glyphicon glyphicon-menu-down") {
          this.menuClass = "glyphicon glyphicon-menu-up";
        } else {
          this.menuClass = "glyphicon glyphicon-menu-down";
        }
      }
    }
  };

</script>
<style scoped>
  /* 顶部 */
  #header {
    background: #fff;
    transition: all ease 0.6s;
  }

  /* 导航栏 */
  #header .header-nav {
    height: 110px;
  }

  /* 导航栏logo */
  #header .header-nav .header-nav-logo {
    width: 100px;
    height: 100%;
    float: left;
    position: relative;
  }

  /* 导航栏logo图片 */
  #header .header-nav .header-nav-logo img {
    width: 130px;
    height: 54px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }

  #header .header-nav .header-nav-logo img.logo-title {
    width: 150px;
    height: 54px;
    position: absolute;
    top: 0;
    left: 160px;
    right: 0;
    bottom: 0;
    margin: auto;
    padding-left: 20px;
    border-left: 1px solid #ccc;
  }

  /* 导航栏 导航容器 */
  #header .header-nav-fixed .header-nav-wrapper {
    line-height: 50px;
  }

  #header .header-nav .header-nav-wrapper {
    line-height: 110px;
    float: right;
    margin: 0;
    max-width: 800px;
  }

  /* 导航中的电话号码 */
  .header-nav-wrapper .header-nav-phone {
    /* vertical-align: middle; */
    margin-left: 60px;
  }

  .header-nav-wrapper .header-nav-phone div {
    position: absolute;
    left: -30px;
    font-weight: bold;
  }

  /* 导航栏 每个导航 */
  #header .header-nav .header-nav-wrapper>li {
    float: left;
    margin: 0 15px;
    position: relative;
  }

  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav .header-nav-wrapper>li>a {
    color: #000;
    font-size: 16px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }

  /* 导航栏 每个导航下面的 a 链接的下划线 */
  #header .header-nav .header-nav-wrapper>li>a>i {
    display: block;
    position: absolute;
    bottom: -2px;
    left: 50%;
    width: 0;
    height: 2px;
    opacity: 0;
    transition: all 0.6s ease;
    background-color: #409EFF;
  }

  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper>li>a>span {
    font-size: 12px;
    transition: transform ease 0.5s;
  }

  /* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
  #header .header-nav .header-nav-wrapper>li>a:hover {
    color: #409EFF;
    text-decoration: none;
  }

  /* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
  #header .header-nav .header-nav-wrapper>li>a:hover .underline {
    opacity: 1;
    width: 100%;
    left: 0;
  }

  /* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
  #header .header-nav .header-nav-wrapper>li>a:hover span {
    transform: rotate(180deg);
  }

  /* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
  #header .header-nav .header-nav-wrapper>li.active>a {
    color: #409EFF;
    text-decoration: none;
    border-bottom: 2px solid #409EFF;
  }

  /* 导航栏 每个导航下面的二级导航容器 */
  #header .header-nav .header-nav-wrapper>li>dl {
    display: none;
    position: absolute;
    width: 168px;
    top: 100%;
    left: 0;
    z-index: 999999;
    box-shadow: 0 0 3px 1px rgba(218, 218, 218, 0.1);
    background: #fff;
  }

  /* 导航栏 每个导航下面的二级导航容器的每个导航 */
  #header .header-nav .header-nav-wrapper>li>dl>dt {
    width: 100%;
    padding: 10px;
    /* border-bottom: 1px solid #ccc; */
  }

  #header .header-nav .header-nav-wrapper>li>dl>dt>a {
    color: #333;
  }

  /* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
  #header .header-nav .header-nav-wrapper>li>dl>dt>a:hover {
    text-decoration: none;
    color: #fff;
    font-weight: bold;
  }

  /* 导航栏 滑上一级导航显示二级导航 */
  #header .header-nav .header-nav-wrapper>li:hover dl {
    display: block;
  }

  #header .header-nav .header-nav-wrapper>li>dl>dt:hover {
    cursor: pointer;
    background: #409EFF;
  }

  #header .header-nav .header-nav-wrapper>li>dl>dt:hover a {
    cursor: pointer;
    color: #fff;
    font-weight: bold;
  }

  @media screen and (max-width: 997px) {
    #header .header-nav-m {
      position: relative;
    }

    /* 导航栏logo容器 */
    #header .header-nav-m .header-nav-m-logo {
      height: 80px;
      position: relative;
    }

    /* 导航栏logo图片 */
    #header .header-nav-m .header-nav-m-logo img {
      width: 130px;
      height: 54px;
      position: absolute;
      top: 0;
      left: -150px;
      right: 0;
      bottom: 0;
      margin: auto;
    }

    #header .header-nav-m .header-nav-m-logo .center-block-title {
      width: 150px;
      height: 54px;
      position: absolute;
      top: 0;
      left: 150px;
      right: 0;
      bottom: 0;
      margin: auto;
    }

    /* 导航栏  菜单容器 */
    #header .header-nav-m .header-nav-m-menu {
      color: #fff;
      height: 50px;
      font-size: 20px;
      line-height: 50px;
      background: #409EFF;
      position: relative;
    }

    /* 导航栏 菜单图标 */
    #header .header-nav-m .header-nav-m-menu-wrapper {
      position: absolute;
      top: 50%;
      right: 20px;
      margin-top: -20px;
      width: 50px;
      height: 40px;
      color: #fff;
      z-index: 999999;
      font-size: 12px;
    }

    /* 导航栏 */
    #header .header-nav-m .header-nav-m-wrapper {
      position: absolute;
      top: 50px;
      left: 0;
      width: 100%;
      background: #409EFF;
      z-index: 9999999;
    }

    /* 导航栏 每个导航 */
    #header .header-nav-m .header-nav-m-wrapper>li {
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #fff;
    }

    /* 导航栏 每个导航下面的 a 链接 */
    #header .header-nav-m .header-nav-m-wrapper>li>a {
      color: #fff;
      font-size: 15px;
      font-weight: bold;
      padding: 15px 0;
      position: relative;
    }

    /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
    #header .header-nav .header-nav-wrapper>li>a>span {
      font-size: 10px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Header.vue